import { AnimatedStrokeSvg } from './AnimatedScribble';

const defaultLogoSrc = '/auth/assets/svgs/logomark.svg';

type LogoMarkProps = {
    className?: string;
    src?: string;
    title?: string;
};

export default function LogoMark({ className, src = defaultLogoSrc, title }: LogoMarkProps) {
    return (
        <AnimatedStrokeSvg
            ariaLabel={title}
            className={className}
            delayMs={150}
            durationMs={1200}
            revealFilledShapes
            src={src}
            staggerMs={0}
        />
    );
}
